import React, { useEffect, useState } from "react";
import "../styles/AcordionesHistorialClinico.scss"
import TextArea from "antd/es/input/TextArea";
import { Select, Button, Row, Col, Menu, Layout } from "antd";
import TextAreaAntd from "../../../componentes/GeneralComponents/TextAreaAntd";
import InputAntd from "../../../componentes/GeneralComponents/InputAntd";
import SelectAntd from "../../../componentes/GeneralComponents/SelectAntd";
import {
    getEstado_request,
    getLocalidad_request,
    addExpediente_request,
    getHistoriasClinicas_request,
} from "../../../services/expediente_service";

import dayjs from "dayjs";
import "dayjs/locale/es";
import locale from "antd/es/date-picker/locale/es_ES";
import { Loader } from "../../GeneralComponents/Loader";

// Librerias mui acordion
import { Accordion, Box, Divider } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckGuardar from "../../../Img/Iconos/checkmark_white.svg";

import { Label } from "../../GeneralComponents/Formularios";
import { Cancel, Edit } from "@mui/icons-material";

import InputDate from "../../GeneralComponents/InputDate";
import { chars } from "../../../utils/utils";
import { Content, Header } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { useSelector } from 'react-redux';

function NewHistorialClinico({ setEdad, tipoSangreSet, Historial, getHistoriaClinica, mensajesError, setLoader, DatosContacto, navBar }) {
    let data = JSON.parse(sessionStorage.getItem("infoUser"));
    const professions = useSelector((state) => state.userInfo.profesiones);

    const [isPediatra, setIsPediatra] = useState(!!professions.find(item => item.Profesion === 'Pediatría'));

    const [DisabledInputs, setDisabledInputs] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    // VARIABLES HISTORIA CLINICA
    const [TipoSangre, setTipoSangre] = useState("");
    const [Alergias, setAlergias] = useState("");
    const [Refiere, setRefiere] = useState("");
    const [ObservacionesPaciente, setObservacionesPaciente] = useState("");
    const [EstadoCivil, setEstadoCivil] = useState(null);
    const [Ocupacion, setOcupacion] = useState("");
    const [Sexo, setSexo] = useState(null);
    const [Nacimiento, setNacimiento] = useState("");
    const [Nacionalidad, setNacionalidad] = useState("");
    const [Estado, setEstado] = useState(null);
    const [Localidad, setLocalidad] = useState(null);
    const [CodigoPostal, setCodigoPostal] = useState("");
    const [NombrePareja, setNombrePareja] = useState("");
    const [NacimientoPareja, setNacimientoPareja] = useState("");
    const [EdadPareja, setEdadPareja] = useState("");
    const [OcupacionPareja, setOcupacionPareja] = useState("");
    const [NotasPareja, setNotasPareja] = useState("");
    const [AHeredoFamiliares, setAHeredoFamiliares] = useState("");
    const [APersonalesPatologicos, setAPersonalesPatologicos] = useState("");
    const [APersonalesNoPatologicos, setAPersonalesNoPatologicos] = useState("");
    const [AAndroGineGeneral, setAAndroGineGeneral] = useState("");
    const [AAndroGine, setAAndroGine] = useState("");
    const [Embarazada, setEmbarazada] = useState(0);
    const [SignosSintomas, setSignosSintomas] = useState("");
    const [AparatoCardiovascular, setAparatoCardiovascular] = useState("");
    const [AparatoRespiratorio, setAparatoRespiratorio] = useState("");
    const [AparatoDigestivo, setAparatoDigestivo] = useState("");
    const [SistemaNefrourologico, setSistemaNefrourologico] = useState("");
    const [SistemaEndocrino, setSistemaEndocrino] = useState("");
    const [SistemaHematoproyetico, setSistemaHematoproyetico] = useState("");
    const [SistemaNervioso, setSistemaNervioso] = useState("");
    const [MusculoEsqueletico, setMusculoEsqueletico] = useState("");
    const [PielTegumentos, setPielTegumentos] = useState("");
    const [OrganosSentidos, setOrganosSentidos] = useState("");
    const [EsferaPsiquica, setEsferaPsiquica] = useState("");
    const [Genitales, setGenitales] = useState("");

    const [ScreenView, setScreenView] = useState("1");

    // #### INICIO DE VARIABLES CONSULTA/NOTA EVOLUCION ####

    const [EstadosList, setEstadosList] = useState([]);
    const [LocalidadesList, setLocalidadesList] = useState([]);

    const [MensajeSexo, setMensajeSexo] = useState("true");
    const [MensajeNacimiento, setMensajeNacimiento] = useState("true");
    const [MensajeNacimientoPareja, setMensajeNacimientoPareja] = useState("true");
    const [MensajeNacimientoPadreTutor, setMensajeNacimientoPadreTutor] = useState("true");
    const [MensajeNacimientoMadreTutor, setMensajeNacimientoMadreTutor] = useState("true");

    const [nameMainTutor, setNameMainTutor] = useState("");
    const [professionMainTutor, setProfessionMainTutor] = useState("");
    const [NacimientoPadreTutor, setNacimientoPadreTutor] = useState("");
    const [ageMainTutor, setAgeMainTutor] = useState("");
    const [noteMainTutor, setNoteMainTutor] = useState("");
    const [nameExtraTutor, setNameExtraTutor] = useState("");
    const [professionExtraTutor, setProfessionExtraTutor] = useState("");
    const [NacimientoMadreTutor, setNacimientoMadreTutor] = useState("");
    const [ageExtraTutor, setAgeExtraTutor] = useState("");
    const [noteExtraTutor, setNoteExtraTutor] = useState("");

    async function setHistoriaClinica() {
        if (Historial.historial !== null) {
            setTipoSangre(Historial.historial.tipoSangre);
            tipoSangreSet(Historial.historial.tipoSangre);
            setAlergias(Historial.historial.alergias);
            setRefiere(Historial.historial.refiere);
            setObservacionesPaciente(Historial.historial.observaciones);
            setAHeredoFamiliares(Historial.historial.aHereditarios);
            setAPersonalesPatologicos(Historial.historial.aPatologicos);
            setAPersonalesNoPatologicos(Historial.historial.aNoPatologicos);
            setAAndroGineGeneral(Historial.historial.aBiologicoGeneral);
            setAAndroGine(Historial.historial.aBiologicoEspecifico);
            setSignosSintomas(Historial.historial.sGenerales);
            setAparatoCardiovascular(Historial.historial.aCardiovascular);
            setAparatoRespiratorio(Historial.historial.aRespiratorio);
            setAparatoDigestivo(Historial.historial.aDigestivo);
            setSistemaNefrourologico(Historial.historial.sNefrourologico);
            setSistemaEndocrino(Historial.historial.sEndocrino);
            setSistemaHematoproyetico(Historial.historial.sHematopoyetico);
            setSistemaNervioso(Historial.historial.sNervioso);
            setMusculoEsqueletico(Historial.historial.sMusculo);
            setPielTegumentos(Historial.historial.piel);
            setOrganosSentidos(Historial.historial.oSentidos);
            setEsferaPsiquica(Historial.historial.ePsiquica);
            setGenitales(Historial.historial.sGenitales);
            setEstadoCivil(Historial.historial.estadoCivil !== null ? Historial.historial.estadoCivil.toString() : null);
            setOcupacion(Historial.historial.ocupacion);
            setNombrePareja(Historial.historial.nombrePareja);
            setOcupacionPareja(Historial.historial.ocupacionPareja);
            setNotasPareja(Historial.historial.nota);
            setNameMainTutor(Historial.historial.nombrePadreTutor || "");
            setProfessionMainTutor(Historial.historial.ocupacionPadreTutor || "");
            setNoteMainTutor(Historial.historial.notaPadreTutor || "");
            setNameExtraTutor(Historial.historial.nombreMadreTutor || "");
            setProfessionExtraTutor(Historial.historial.ocupacionMadreTutor || "");
            setNoteExtraTutor(Historial.historial.notaMadreTutor || "");
            if (isPediatra) {
                if (Historial.historial.nacimientoPadreTutor) {
                    let arrayFechaTemp = Historial.historial.nacimientoPadreTutor.split("-");
                    let fechaTemp = `${arrayFechaTemp[2]}/${arrayFechaTemp[1]}/${arrayFechaTemp[0]}`;
                    if (arrayFechaTemp.length === 3) {
                        setAgeMainTutor(getEdad(`${arrayFechaTemp[0]}/${arrayFechaTemp[1]}/${arrayFechaTemp[2]}`));
                        setNacimientoPadreTutor(fechaTemp);
                    }
                }

                if (Historial.historial.nacimientoMadreTutor) {
                    let arrayFechaTemp = Historial.historial.nacimientoMadreTutor.split("-");
                    let fechaTemp = `${arrayFechaTemp[2]}/${arrayFechaTemp[1]}/${arrayFechaTemp[0]}`;
                    if (arrayFechaTemp.length === 3) {
                        setAgeExtraTutor(getEdad(`${arrayFechaTemp[0]}/${arrayFechaTemp[1]}/${arrayFechaTemp[2]}`));
                        setNacimientoMadreTutor(fechaTemp);
                    }
                }
            } else {
                if (Historial.historial.nacimientoPareja) {
                    let arrayFechaTemp = Historial.historial.nacimientoPareja.split("-");
                    let fechaTemp = `${arrayFechaTemp[2]}/${arrayFechaTemp[1]}/${arrayFechaTemp[0]}`;
                    if (arrayFechaTemp.length === 3) {
                        setEdadPareja(getEdad(`${arrayFechaTemp[0]}/${arrayFechaTemp[1]}/${arrayFechaTemp[2]}`));
                        setNacimientoPareja(fechaTemp);
                    }
                }
            }
        }

        if (Historial.ficha !== null) {
            setSexo(Historial.ficha.sexo);

            if (!!Historial.ficha.fechaNacimiento) {
                let arrayFechaTemp = Historial.ficha.fechaNacimiento.split("-");
                let fechaTemp = `${arrayFechaTemp[0]}/${arrayFechaTemp[1]}/${arrayFechaTemp[2]}`;
                if (arrayFechaTemp.length === 3) {
                    setEdad(getEdad(`${arrayFechaTemp[2]}/${arrayFechaTemp[1]}/${arrayFechaTemp[0]}`));
                    setNacimiento(fechaTemp);
                }
            }
            setNacionalidad(Historial.ficha.nacionalidad);
            if (!!Historial.ficha.estado) {
                setEstado(Historial.ficha.estado);
                getLocalidades(Historial.ficha.estado);
                setLocalidad(Historial.ficha.localidad);
            }
            setCodigoPostal(Historial.ficha.cp);
        }
    }

    async function getEstados() {
        let response = await getEstado_request();

        if (response.ok) {
            let estados_temp = [];
            response.data.forEach((estado) => {
                estados_temp.push({
                    value: estado.id.toString(),
                    label: estado.Estado,
                });
            });
            setEstadosList(estados_temp);
        } else {
            setEstadosList([]);
        }
    }

    async function getLocalidades(estado) {
        let response = await getLocalidad_request(estado);

        if (response.ok) {
            let localidades_temp = [];
            response.data.forEach((estado) => {
                localidades_temp.push({ value: estado, label: estado });
            });
            setLocalidadesList(localidades_temp);
        } else {
            setLocalidadesList([]);
        }
    }

    async function saveHClinico() {
        setIsLoading(true);

        if (!!Sexo && !!Nacimiento) {
            let data = {
                aBiologicoGeneral: AAndroGineGeneral,
                aBiologicoEspecifico: AAndroGine,
                aCardiovascular: AparatoCardiovascular,
                aDigestivo: AparatoDigestivo,
                aHereditarios: AHeredoFamiliares,
                aNoPatologicos: APersonalesNoPatologicos,
                aPatologicos: APersonalesPatologicos,
                aRespiratorio: AparatoRespiratorio,
                ePsiquica: EsferaPsiquica,
                oSentidos: OrganosSentidos,
                piel: PielTegumentos,
                sEndocrino: SistemaEndocrino,
                sGenerales: SignosSintomas,
                sGenitales: Genitales,
                sHematopoyetico: SistemaHematoproyetico,
                sMusculo: MusculoEsqueletico,
                sNefrourologico: SistemaNefrourologico,
                sNervioso: SistemaNervioso,
                alergias: Alergias,
                observaciones: ObservacionesPaciente,
                refiere: Refiere,
                sexo: Sexo,
                nacimiento: parseDateToSend(Nacimiento),
                nacionalidad: Nacionalidad,
                estado: Estado,
                localidad: Localidad,
                cp: CodigoPostal,
                tipoSangre: TipoSangre,
                ocupacion: Ocupacion,
                estadoCivil: EstadoCivil,
                nombrePareja: NombrePareja,
                edadPareja: EdadPareja,
                ocupacionPareja: OcupacionPareja,
                nota: NotasPareja,
            };

            if (isPediatra) {
                data.nacimientoPadreTutor = parseDateToSend(NacimientoPadreTutor);
                data.nacimientoMadreTutor = parseDateToSend(NacimientoMadreTutor);
            } else {
                data.nacimientoPareja = parseDateToSend(NacimientoPareja);
            }

            let response = await addExpediente_request(data, DatosContacto.id);

            if (response.ok) {
                mensajesError.setOpen(true);
                mensajesError.setTypeMessage("success");
                mensajesError.setMessage("Cambios guardados");
                setDisabledInputs(true);
                getHistoriaClinica();
            } else {
                mensajesError.setOpen(true);
                mensajesError.setTypeMessage("error");
                mensajesError.setMessage(response.mensaje);
            }
        } else {
            if (!!!Sexo) {
                setMensajeSexo("false");
            }
            if (!!!Nacimiento) {
                setMensajeNacimiento("false");
            }

            mensajesError.setOpen(true);
            mensajesError.setTypeMessage("warning");
            mensajesError.setMessage("Faltan campos por completar");

        }
        setIsLoading(false);
        return;
    }

    function parseDateToSend(date) {
        let arrayFecha = date.split("/");
        let fechaFinal = `${arrayFecha[2]}-${arrayFecha[1]}-${arrayFecha[0]}`;
        return fechaFinal;
    }

    function getEdad(dateString) {
        let hoy = new Date();
        let fNacimiento = new Date(dateString.replace(/-/g, "/"));
        let edadAnios = hoy.getFullYear() - fNacimiento.getFullYear();
        let edadMeses = hoy.getMonth() - fNacimiento.getMonth();
        let edadDias = hoy.getDate() - fNacimiento.getDate();

        if (edadDias < 0) {
            edadMeses--;
        }
        if (edadMeses < 0) {
            edadAnios--;
            edadMeses += 12;
        }

        if (isPediatra) {
            if (edadAnios < 1) {
                return `${edadMeses} mes${edadMeses === 1 ? '' : 'es'}`;
            } else {
                let texto = `${edadAnios} año${edadAnios === 1 ? '' : 's'}`;
                if (edadMeses > 0) {
                    texto += ` y ${edadMeses} mes${edadMeses === 1 ? '' : 'es'}`;
                }
                return texto;
            }
        } else {
            return edadAnios;
        }
    }

    function filterOptions(input, option) {
        var expr = /[áàéèíìóòúùñ]/ig;
        return option?.label.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(input.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1
    }

    function filterSort(optionA, optionB) {
        var expr = /[áàéèíìóòúùñ]/ig;
        return (optionA?.label.replace(expr, function (e) { return chars[e] }).toLowerCase() ?? "").replace(expr, function (e) { return chars[e] }).toLowerCase().localeCompare((optionB?.label.replace(expr, function (e) { return chars[e] }).toLowerCase() ?? "").replace(expr, function (e) { return chars[e] }).toLowerCase())
    }

    useEffect(() => {
        getEstados();
        setHistoriaClinica();
    }, []);

    // if (isLoading) {
    //     return (<Loader />)
    // }
    const renderTutorOrCouple = () => {
        if (isPediatra) {
            return (
                <Box>
                    <Box>
                        <InputAntd
                            label="Nombre:"
                            className="inputblue"
                            value={nameMainTutor}
                            setStateValue={setNameMainTutor}
                            placeholder="Escriba un nombre completo"
                            vacio={true}
                            styleDiv={{ width: "100%" }}
                        />
                        <Row style={{ justifyContent: "space-between" }}>
                            <InputAntd
                                className="inputblue"
                                value={professionMainTutor}
                                setStateValue={setProfessionMainTutor}
                                label="Ocupación:"
                                placeholder="Escribe una ocupación"
                                vacio={true}
                                styleDiv={{ width: "40%" }}
                            />

                            <InputDate
                                label="Nacimiento:"
                                placeholder="DD/MM/AAAA"
                                style={{ width: "100%", background: "white" }}
                                value={!!NacimientoPadreTutor ? NacimientoPadreTutor : ""}
                                setStateValue={setNacimientoPadreTutor}
                                styleDiv={{ width: "40%" }}
                                setEdad={setAgeMainTutor}
                                setStateError={setMensajeNacimientoPadreTutor}
                                valueError={MensajeNacimientoPadreTutor}
                                textError={["Debe elegir una fecha de nacimiento", "Fecha no válida"]}
                                vacio={false}
                                disabled={DisabledInputs}
                            />

                            <InputAntd
                                label="Edad:"
                                className="inputblue"
                                value={ageMainTutor}
                                setStateValue={setAgeMainTutor}
                                placeholder="Edad"
                                vacio={true}
                                styleDiv={{ width: "10%" }}
                                maxLength={2}
                                readOnly={true}
                            />

                        </Row>
                        <TextAreaAntd
                            label="Notas/Comentarios:"
                            value={noteMainTutor}
                            placeholder="Escriba una nota o comentario"
                            style={{
                                // margin: ".5% 0",
                                marginBottom: ".5%",
                                fontFamily: "sans-serif",
                            }}
                            columns="30"
                            autoSize={true}
                            setStateValue={setNoteMainTutor}
                        />
                    </Box>
                    <Divider> <Typography>Otro tutor</Typography> </Divider>
                    <Box>
                        <InputAntd
                            label="Nombre:"
                            className="inputblue"
                            value={nameExtraTutor}
                            setStateValue={setNameExtraTutor}
                            placeholder="Escriba un nombre completo"
                            vacio={true}
                            styleDiv={{ width: "100%" }}
                        // maxLength={15}
                        />
                        <Row style={{ justifyContent: "space-between" }}>
                            <InputAntd
                                className="inputblue"
                                value={professionExtraTutor}
                                setStateValue={setProfessionExtraTutor}
                                label="Ocupación:"
                                placeholder="Escribe una ocupación"
                                vacio={true}
                                styleDiv={{ width: "40%" }}
                            />

                            <InputDate
                                label="Nacimiento:"
                                placeholder="DD/MM/AAAA"
                                style={{ width: "100%", background: "white" }}
                                value={!!NacimientoMadreTutor ? NacimientoMadreTutor : ""}
                                setStateValue={setNacimientoMadreTutor}
                                styleDiv={{ width: "40%" }}
                                setEdad={setAgeExtraTutor}
                                setStateError={setMensajeNacimientoMadreTutor}
                                valueError={MensajeNacimientoMadreTutor}
                                textError={["Debe elegir una fecha de nacimiento", "Fecha no válida"]}
                                vacio={false}
                                disabled={DisabledInputs}
                            />

                            <InputAntd
                                label="Edad:"
                                className="inputblue"
                                value={ageExtraTutor}
                                setStateValue={setAgeExtraTutor}
                                placeholder="Edad"
                                vacio={true}
                                readOnly={true}
                                styleDiv={{ width: "10%" }}
                                maxLength={2}
                            />
                        </Row>
                        <TextAreaAntd
                            label="Notas/Comentarios:"
                            value={noteExtraTutor}
                            placeholder="Escriba una nota o comentario"
                            style={{
                                marginBottom: ".5%",
                                fontFamily: "sans-serif",
                            }}
                            columns="30"
                            autoSize={true}
                            setStateValue={setNoteExtraTutor}
                        />
                    </Box>
                </Box>
            );
        } else {
            return (
                <Box>
                    <InputAntd
                        label="Nombre:"
                        className="inputblue"
                        value={NombrePareja}
                        setStateValue={setNombrePareja}
                        placeholder="Escriba un nombre completo"
                        vacio={true}
                        styleDiv={{ width: "100%" }}
                    // maxLength={15}
                    />
                    <Row style={{ justifyContent: "space-between" }}>
                        <InputAntd
                            className="inputblue"
                            value={OcupacionPareja}
                            setStateValue={setOcupacionPareja}
                            label="Ocupación:"
                            placeholder="Escribe una ocupación"
                            // valueError={MensajeAddNombrecontacto}
                            vacio={true}
                            // disabled={false}
                            // expresionRegular={expresiones.Letras}
                            styleDiv={{ width: "40%" }}
                        />

                        <InputDate
                            label="Nacimiento:"
                            placeholder="DD/MM/AAAA"
                            style={{ width: "100%", background: "white" }}
                            value={!!NacimientoPareja ? NacimientoPareja : ""}
                            setStateValue={setNacimientoPareja}
                            styleDiv={{ width: "40%" }}
                            setEdad={setEdadPareja}
                            setStateError={setMensajeNacimientoPareja}
                            valueError={MensajeNacimientoPareja}
                            textError={["Debe elegir una fecha de nacimiento", "Fecha no válida"]}
                            vacio={false}
                            disabled={DisabledInputs}
                        />

                        <InputAntd
                            label="Edad:"
                            className="inputblue"
                            value={EdadPareja}
                            setStateValue={setEdadPareja}
                            placeholder="Edad"
                            vacio={true}
                            readOnly={true}
                            styleDiv={{ width: "10%" }}
                            maxLength={2}
                        />
                    </Row>
                    <TextAreaAntd
                        label="Notas/Comentarios:"
                        value={NotasPareja}
                        placeholder="Escriba una nota o comentario"
                        style={{
                            // margin: ".5% 0",
                            marginBottom: ".5%",
                            fontFamily: "sans-serif",
                        }}
                        columns="30"
                        autoSize={true}
                        setStateValue={setNotasPareja}
                    />
                </Box>
            );
        }
    };

    return (
        <div className="gridExpedienteDetalle">
            <Col span={12}>
                <div className="ScrollLeftContent" style={{ width: "30vw" }}>
                    <Menu
                        defaultSelectedKeys={ScreenView}
                        items={[
                            {
                                key: 1,
                                label: "Informacion General",
                                onClick: (e) => {
                                    console.log(e);
                                    setScreenView(e.key);
                                }
                            },
                            {
                                key: 2,
                                label: isPediatra ? 'Datos de tutores' : "Datos de pareja",
                                onClick: (e) => {
                                    console.log(e);
                                    setScreenView(e.key);
                                }
                            },
                            {
                                key: 3,
                                label: "Antecedentes heredo-familiares",
                                onClick: (e) => {
                                    console.log(e);
                                    setScreenView(e.key);
                                }
                            },
                            {
                                key: 4,
                                label: "Antecedentes personales patológicos",
                                onClick: (e) => {
                                    console.log(e);
                                    setScreenView(e.key);
                                }
                            },
                            {
                                key: 5,
                                label: "Antecedentes personales no patológicos",
                                onClick: (e) => {
                                    console.log(e);
                                    setScreenView(e.key);
                                }
                            },
                            {
                                key: 6,
                                label: isPediatra ? "Antecedentes perinatales" : (
                                    Sexo === "Masculino" ? "Antecedentes andrológicos" : "Antecedentes gineco-obstetricos"
                                ),
                                onClick: (e) => {
                                    console.log(e);
                                    setScreenView(e.key);
                                }
                            },
                            {
                                key: 7,
                                label: "Interrogatorio por aparatos y sistemas",
                                onClick: (e) => {
                                    console.log(e);
                                    setScreenView(e.key);
                                }
                            },
                        ]}
                    />
                </div>
            </Col>
            <Col span={12}>
                <div className="ScrollRigthContent" style={{ width: "70vw" }}>
                    {(data.Tipo === 1 && (<div
                        style={{

                            display: "flex",
                            justifyContent: "end",
                            background: "#fff"

                        }}
                    >
                        {DisabledInputs ? (
                            <Button
                                onClick={() => {
                                    setDisabledInputs(false);
                                }}
                                style={{
                                    backgroundColor: "#148f9f",
                                    color: "white",
                                    width: "100px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginTop: "10px",
                                }}
                            >
                                <div>Editar</div>
                                <Edit
                                    sx={{ width: "20%" }}
                                    fontSize="small"
                                />
                            </Button>
                        ) : (
                            <Row style={{ width: "20%", justifyContent: "space-between" }}>
                                <Button
                                    onClick={() => {
                                        setDisabledInputs(true);
                                    }}
                                    style={{
                                        backgroundColor: "#fffff",
                                        color: "#148f9f",
                                        width: "100px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "10px",
                                    }}
                                >


                                    <div>Cancelar</div>
                                    <Cancel />
                                    {/* <img
                                        style={{ width: "12px", height: "12px" }}
                                        src={CheckC}
                                        alt=""
                                    /> */}

                                </Button>
                                <Button
                                    onClick={() => {
                                        saveHClinico();
                                    }}
                                    style={{
                                        backgroundColor: "#148f9f",
                                        color: "white",
                                        width: "100px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "10px",
                                    }}
                                >


                                    <div>Guardar</div>
                                    <img
                                        style={{ width: "12px", height: "12px" }}
                                        src={CheckGuardar}
                                        alt=""
                                    />

                                </Button>
                            </Row>
                        )}
                    </div>))}
                    {ScreenView === "1" && (
                        <div style={{ width: "100%", padding: "1%", background: "#fff" }}>
                            <InputAntd
                                label="Tipo de sangre:"
                                className="inputblue"
                                value={TipoSangre}
                                setStateValue={setTipoSangre}
                                placeholder="Tipo de sangre"
                                vacio={true}
                                readOnly={DisabledInputs}
                                styleDiv={{ width: "130px" }}
                            />
                            <TextAreaAntd
                                label="Alergias:"
                                value={Alergias}
                                placeholder="Alergias"
                                style={{
                                    // margin: ".5% 0",
                                    marginBottom: ".5%",
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                }}
                                columns="30"
                                autoSize={true}
                                setStateValue={setAlergias}
                                readOnly={DisabledInputs}
                            />


                            <TextAreaAntd
                                styleDiv={{ width: "100%" }}
                                label="Quien Refiere:"
                                value={Refiere}
                                placeholder="Quien Refiere"
                                style={{
                                    // margin: ".5% 0",
                                    marginBottom: ".5%",
                                    fontFamily: "sans-serif",
                                }}
                                columns="30"
                                autoSize={true}
                                setStateValue={setRefiere}
                                readOnly={DisabledInputs}
                            />
                            <TextAreaAntd
                                styleDiv={{ width: "100%" }}
                                label="Observaciones sobre el paciente:"
                                value={ObservacionesPaciente}
                                placeholder="Observaciones sobre el paciente"
                                style={{
                                    // margin: ".5% 0",
                                    marginBottom: ".5%",
                                    fontFamily: "sans-serif",
                                }}
                                columns="30"
                                autoSize={true}
                                setStateValue={setObservacionesPaciente}
                                readOnly={DisabledInputs}
                            />
                            {
                                !isPediatra ? (
                                    <div className="BotonesHistorial">
                                        <SelectAntd
                                            label="Estado civil:"
                                            value={EstadoCivil}
                                            style={{ width: "100%" }}
                                            placeholder="Seleccione un estado civil"
                                            options={
                                                [
                                                    { value: "0", label: "Soltero/a" },
                                                    { value: "1", label: "Casado/a" },
                                                    { value: "2", label: "Viudo/a" },
                                                    { value: "3", label: "Divorciado/a" },
                                                    { value: "4", label: "Separado/a" },
                                                    { value: "5", label: "Concubinato" },
                                                ]
                                            }
                                            setStateValue={setEstadoCivil}
                                            styleDiv={{ width: "100%" }}
                                            disabled={DisabledInputs}
                                        />
                                        <InputAntd
                                            className="inputblue"
                                            value={Ocupacion}
                                            setStateValue={setOcupacion}
                                            label="Ocupación:"
                                            placeholder="Escribe una ocupación"
                                            vacio={true}
                                            styleDiv={{ width: "100%" }}
                                            readOnly={DisabledInputs}
                                        />
                                    </div>
                                ) : null
                            }

                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2%",
                                    justifyContent: "space-between",
                                }}
                            >
                                <SelectAntd
                                    label="Género:"
                                    value={Sexo}
                                    style={{ width: "100%" }}
                                    styleDiv={{ width: "100%" }}
                                    placeholder="Género"
                                    options={[
                                        { value: "Femenino", label: "Femenino" },
                                        { value: "Masculino", label: "Masculino" },
                                    ]}
                                    setStateValue={setSexo}
                                    disabled={DisabledInputs}
                                    setStateError={setMensajeSexo}
                                    valueError={MensajeSexo}
                                    textError={["Debe elegir un género"]}
                                    vacio={false}
                                />
                                <InputDate
                                    label="Nacimiento:"
                                    placeholder="DD/MM/AAAA"
                                    style={{ width: "100%", background: "white" }}
                                    value={!!Nacimiento ? Nacimiento : ""}
                                    setStateValue={setNacimiento}
                                    styleDiv={{ width: "45%" }}
                                    setEdad={setEdad}
                                    setStateError={setMensajeNacimiento}
                                    valueError={MensajeNacimiento}
                                    textError={["Debe elegir una fecha de nacimiento", "Fecha no válida"]}
                                    vacio={false}
                                    disabled={DisabledInputs}
                                />
                            </div>

                            <div
                                className="BotonesHistorial"
                            >
                                <InputAntd
                                    className="inputblue"
                                    value={Nacionalidad}
                                    setStateValue={setNacionalidad}
                                    label="Nacionalidad:"
                                    placeholder="Nacionalidad"
                                    vacio={true}
                                    styleDiv={{ width: "100%" }}
                                    disabled={DisabledInputs}
                                />
                                <div style={{ width: "100%" }}>
                                    <Label>Estado:</Label>
                                    <Select
                                        disabled={DisabledInputs}
                                        showSearch
                                        style={{
                                            width: "100%",
                                            margin: ".5% 0",
                                        }}
                                        placeholder="Estado"
                                        optionFilterProp="children"
                                        filterOption={filterOptions}
                                        filterSort={filterSort}
                                        value={Estado}
                                        onSelect={(e) => {
                                            setEstado(e);
                                            getLocalidades(e);
                                        }}
                                        options={EstadosList}
                                    />
                                </div>
                                <div style={{ width: "100%" }}>
                                    <Label>Localidad:</Label>
                                    <Select
                                        showSearch
                                        style={{
                                            width: "100%",
                                            margin: ".5% 0",
                                        }}
                                        placeholder="Localidad"
                                        optionFilterProp="children"
                                        filterOption={filterOptions}
                                        filterSort={filterSort}
                                        value={Localidad}
                                        onSelect={(e) => {
                                            setLocalidad(e);
                                        }}
                                        options={LocalidadesList}
                                        disabled={
                                            LocalidadesList.length === 0
                                                ? true
                                                : DisabledInputs
                                                    ? true
                                                    : false
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {ScreenView === "2" && renderTutorOrCouple()}
                    {ScreenView === "3" && (
                        <div style={{ width: "100%", padding: "1%", background: "#fff" }}>
                            <TextArea
                                // readOnly
                                placeholder="Antecedentes heredo-familiares"
                                style={{
                                    margin: ".5% 0",
                                    fontFamily: "sans-serif",
                                    border: "0",
                                }}
                                name=""
                                id=""
                                cols="30"
                                onChange={(e) => {
                                    setAHeredoFamiliares(e.target.value);
                                }}
                                value={AHeredoFamiliares}
                                autoSize
                                readOnly={DisabledInputs}
                            />
                        </div>
                    )}
                    {ScreenView === "4" && (
                        <div style={{ width: "100%", padding: "1%", background: "#fff" }}>
                            <TextArea
                                // readOnly
                                placeholder="Antecedentes personales patológicos"
                                style={{
                                    margin: ".5% 0",
                                    fontFamily: "sans-serif",
                                    border: "0",
                                }}
                                name=""
                                id=""
                                cols="30"
                                onChange={(e) => {
                                    setAPersonalesPatologicos(e.target.value);
                                }}
                                value={APersonalesPatologicos}
                                autoSize
                                readOnly={DisabledInputs}
                            />
                        </div>
                    )}
                    {ScreenView === "5" && (
                        <div style={{ width: "100%", padding: "1%", background: "#fff" }}>
                            <TextArea
                                placeholder="Antecedentes personales no patológicos"
                                style={{
                                    margin: ".5% 0",
                                    fontFamily: "sans-serif",

                                    border: "0",
                                }}
                                onChange={(e) => {
                                    setAPersonalesNoPatologicos(e.target.value);
                                }}
                                value={APersonalesNoPatologicos}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                            />
                        </div>
                    )}
                    {ScreenView === "6" && (
                        <div style={{ width: "100%", padding: "1%", background: "#fff" }}>
                            <label htmlFor="">Generales</label>
                            <TextArea
                                placeholder="Inicio de vida sexual, método de planificación familiar, orientación sexual, si sostiene relaciones sexuales de alto riesgo, alteraciones de la libido, si ha padecido enfermedades de transmisión sexual."
                                style={{
                                    margin: ".5% 0",
                                    fontFamily: "sans-serif",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                onChange={(e) => {
                                    setAAndroGineGeneral(e.target.value);
                                }}
                                value={AAndroGineGeneral}
                                readOnly={DisabledInputs}
                            />
                            <label htmlFor="">
                                {
                                    isPediatra ? ("Perinatales") : (
                                        Sexo === "Masculino" ? "Andrológicos específicos" : "Ginecoobstetricos"
                                    )
                                }
                            </label>
                            <TextArea
                                placeholder={
                                    Sexo === "Masculino"
                                        ? "Priapismo, alteraciones de la erección y/o eyaculación, secreción uretral, dolor testicular, alteraciones escrotales, enfermedades de transmisión sexual."
                                        : "Menarca, Telarca, Pubarca, Gestas, Partos Cesáreas, Abortos, Dismenorreas, Ciclo menstrual."
                                }
                                style={{
                                    margin: ".5% 0",
                                    fontFamily: "sans-serif",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                onChange={(e) => {
                                    setAAndroGine(e.target.value);
                                }}
                                value={AAndroGine}
                                readOnly={DisabledInputs}
                            />
                        </div>
                    )}
                    {ScreenView === "7" && (
                        <div style={{ width: "100%", padding: "1%", background: "#fff" }}>
                            <label htmlFor="">Signos y síntomas generales</label>
                            <TextArea
                                placeholder="Fiebre, cefalea, astenia, adinamia y anorexia."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={SignosSintomas}
                                onChange={(e) => {
                                    setSignosSintomas(e.target.value);
                                }}
                            />

                            <label htmlFor="">Aparato cardiovascular</label>
                            <TextArea
                                placeholder="Disnea, dolor precordial, palpitaciones, sincope, lipotimia, edema, cianosis, acúfenos, fosfenos. "
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={AparatoCardiovascular}
                                onChange={(e) => {
                                    setAparatoCardiovascular(e.target.value);
                                }}
                            />

                            <label style={{ marginTop: "50px" }} htmlFor="" >Aparato respiratorio</label>
                            <TextArea
                                aria-label="Aparato"
                                placeholder="Rinorrea, rinolalia, tos, expectoración, disnea, dolor torácico, epistaxis, disfonía, hemoptisis, vómica, sibilancias audibles a distancia. "
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                    marginTop: "5px"
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={AparatoRespiratorio}
                                onChange={(e) => {
                                    setAparatoRespiratorio(e.target.value);
                                }}
                            />

                            <label htmlFor="">Aparato digestivo</label>
                            <TextArea
                                placeholder="Trastornos de la deglución, de la digestión, de la defecación, nausea, vómito, dolor abdominal, diarrea, constipación, ictericia, rumiación, regurgitación, pirosis, aerofagia, eructos, meteorismos, distención abdominal, flatulencia, hematemesis, características de las heces fecales, diarrea, estreñimiento, acolia, hipocolia, melena, rectorragia, lientería, pujo, tenesmo y prurito anal."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={AparatoDigestivo}
                                onChange={(e) => {
                                    setAparatoDigestivo(e.target.value);
                                }}
                            />

                            <label htmlFor="">Sistema nefrourologico</label>
                            <TextArea
                                placeholder="Dolor renoureteral, hematuria, piuria, coluría, oliguria, tenesmo, control de esfínteres, cólico renal, edema, trastornos en el volumen urinario, nictámero, urgencia, características del chorro urinario."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={SistemaNefrourologico}
                                onChange={(e) => {
                                    setSistemaNefrourologico(e.target.value);
                                }}
                            />

                            <label htmlFor="">Sistema endocrino y metabolismo</label>
                            <TextArea
                                placeholder="Intolerancia al calor o al frio, pérdida o aumento de peso, alteraciones del color de la piel, vello corporal, distribución de la grasa corporal, astenia o adinamia, alteraciones del volumen urinario, amenorreas, ginecomastia, galactorrea, alteraciones de la libido, espasmos o calambres musculares."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={SistemaEndocrino}
                                onChange={(e) => {
                                    setSistemaEndocrino(e.target.value);
                                }}
                            />

                            <label htmlFor="">Sistema hematopoyético</label>
                            <TextArea
                                placeholder="Palidez, rubicundez, adenomegalias, hemorragias, fiebre, fatigabilidad, equimosis, petequias y adenomegalias."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={SistemaHematoproyetico}
                                onChange={(e) => {
                                    setSistemaHematoproyetico(e.target.value);
                                }}
                            />

                            <label htmlFor="">Sistema nervioso</label>
                            <TextArea
                                placeholder="Cefalalgia, pérdida de conocimiento, mareos vértigo y trastornos del equilibrio, movimientos anormales involuntarios, debilidad muscular, convulsiones, trastornos de la visión, dolor hormigueo y adormecimiento, trastornos del sueño."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={SistemaNervioso}
                                onChange={(e) => {
                                    setSistemaNervioso(e.target.value);
                                }}
                            />

                            <label htmlFor="">Sistema musculo esquelético</label>
                            <TextArea
                                placeholder="Mialgias, dolor óseo, artralgias, alteraciones en la marcha, hipotonía, disminución del volumenmuscular, limitación de movimientos y deformidades."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={MusculoEsqueletico}
                                onChange={(e) => {
                                    setMusculoEsqueletico(e.target.value);
                                }}
                            />

                            <label htmlFor="">Piel y tegumentos</label>
                            <TextArea
                                placeholder="Coloración, pigmentación, prurito, características del pelo, uñas, lesiones (primarias y secundarias), hiperhidrosis y xerodermia."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={PielTegumentos}
                                onChange={(e) => {
                                    setPielTegumentos(e.target.value);
                                }}
                            />

                            <label htmlFor="">Órganos de los sentidos</label>
                            <TextArea
                                placeholder="Alteraciones de la visión, de la audición, del olfato, del gusto y del tacto (hipo, hiper o disfunción). Mareo y sensación de líquido en el oído."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={OrganosSentidos}
                                onChange={(e) => {
                                    setOrganosSentidos(e.target.value);
                                }}
                            />

                            <label htmlFor="">Esfera psíquica</label>
                            <TextArea
                                placeholder="Tristeza, euforia, alteraciones del sueño, , terrores nocturnos, ideaciones, miedo exagerado a situaciones comunes, irritabilidad, apatía."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={EsferaPsiquica}
                                onChange={(e) => {
                                    setEsferaPsiquica(e.target.value);
                                }}
                            />

                            <label htmlFor="">Genitourinario</label>
                            <TextArea
                                placeholder="Escriba..."
                                style={{
                                    fontFamily: "sans-serif",
                                    width: "100%",
                                    padding: ".5%",
                                }}
                                name=""
                                id=""
                                cols="30"
                                autoSize
                                readOnly={DisabledInputs}
                                value={Genitales}
                                onChange={(e) => {
                                    setGenitales(e.target.value);
                                }}
                            />
                        </div>
                    )}
                </div>
            </Col>
        </div>
    );
}

export default NewHistorialClinico;